import { useEffect, useState, useRef } from 'react';
import { useFetch } from './useFetch.js';
import ItemList from './ItemList';
import useItemDataAPI from './useItemDataAPI';
import MobileMenuIcon from './MobileMenuIcon';
import Filter from './Filter';
import Modal from './Modal';
import IntersectionObserverFunc from './IntersectionObserverFunc.js';

function Home(props) {
  const {
    slideMenu,
    isMobile,
    showModal,
    currentItem,
    openModal,
    closeModal,
    toNextItem,
    toPreviousItem,
  } = props;

  const hostDev = 'https://uic.softaware.co.uk';
  const hostLive = 'https://umamiinspiration.org.uk';
  const host = window.location.origin !== hostLive ? hostDev : hostLive;
  const categoriesUrl = `${host}/umbraco/api/itemcategories/list`;
  const { data: categoryList } = useFetch(categoriesUrl);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState([]);

  const [activeCategories, setActiveCategories] = useState({
    L1: ['1108'],
    L2: [],
    L3: [],
  });

  const all = '1108';
  const meat = '1091';
  const fish = '1093';
  const vegetarian = '1092';
  const vegan = '1094';
  // const raw = '1095';
  // const freeFrom = '1096';

  const {
    data: itemData,
    isPending,
    error,
  } = useItemDataAPI(page, activeCategories, searchValue, host);

  // infinity scroll
  const loader = useRef(null);

  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting) {
      setPage((prev) => prev + 1);
    }
  };

  IntersectionObserverFunc(loader, handleObserver);

  //search bar
  const clearSearchInput = () => {
    setSearchValue([]);
    setActiveCategories({ L1: [all], L2: [], L3: [] });
    document.getElementById('search-bar')[0].value = '';
  };

  const onSearchInputValue = (value) => {
    setSearchValue([value]);
    setActiveCategories({ L1: [], L2: [], L3: [] });
  };

  const handleSearchValue = (value) => {
    setPage(1);
    if (value !== '') {
      onSearchInputValue(value);
    } else {
      clearSearchInput();
    }
  };

  // filter categories
  const L1TabIds = categoryList && getLevelIds(categoryList[0].categories);
  const L2TabIds = categoryList && getLevelIds(categoryList[1].categories);
  const L3TabIds = categoryList && getLevelIds(categoryList[2].categories);
  const chefsUmamiMamaAboutUmami = ['1078', '1913', '1080'];

  function getLevelIds(categories) {
    return categories.map((category) => {
      return category.id.toString();
    });
  }
  function removeCategoryId(id, array) {
    const index = array.findIndex((val) => val === id);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  function toggleId(id, arr) {
    arr.includes(id) ? removeCategoryId(id, arr) : arr.push(id);
    return arr;
  }

  function returnL1(id, arr) {
    !arr.length > 0
      ? arr.push(id)
      : arr[0] === id
      ? arr.splice(0, 1)
      : arr.splice(0, 1, id);

    return arr;
  }

  function activeL2L3CategoryIds(id, obj) {
    if (id === vegan) {
      toggleId(vegan, obj.L3);
      removeCategoryId(meat, obj.L2);
      removeCategoryId(fish, obj.L2);
      removeCategoryId(vegetarian, obj.L2);
    } else if (id === vegetarian) {
      toggleId(vegetarian, obj.L2);
      removeCategoryId(meat, obj.L2);
      removeCategoryId(fish, obj.L2);
      removeCategoryId(vegan, obj.L3);
    } else if (id === fish || id === meat) {
      const meatOrFish = id === fish ? fish : meat;
      toggleId(meatOrFish, obj.L2);
      removeCategoryId(vegan, obj.L3);
      removeCategoryId(vegetarian, obj.L2);
    } else {
      toggleId(id, obj.L3);
    }
  }

  const handleFilterChange = (e) => {
    e.preventDefault();
    setPage(1);
    setSearchValue([]);
    clearSearchInput();
    const target = e.target;
    const targetId = target.dataset.id;

    if (targetId === all) {
      activeCategories.L1 = [targetId];
      activeCategories.L2 = [];
      activeCategories.L3 = [];
      target.closest('div').nextSibling.classList.remove('fade');
    } else {
      removeCategoryId(all, activeCategories.L1);
      if (L1TabIds.includes(targetId)) {
        if (!chefsUmamiMamaAboutUmami.includes(targetId)) {
          target.closest('div').nextSibling.classList.remove('fade');
          activeCategories.L1 = returnL1(targetId, activeCategories.L1);
        } else {
          target.closest('div').nextSibling.classList.add('fade');
          activeCategories.L1 = returnL1(targetId, activeCategories.L1);
          activeCategories.L2 = [];
          activeCategories.L3 = [];
        }
      }
      if (L2TabIds.includes(targetId) || L3TabIds.includes(targetId)) {
        activeL2L3CategoryIds(targetId, activeCategories);
      }
    }
    const L1Categ =
      Object.values(activeCategories).flat().length > 0
        ? activeCategories.L1
        : [all];
    setActiveCategories({
      L1: L1Categ,
      L2: activeCategories.L2,
      L3: activeCategories.L3,
    });
  };

  return (
    <>
      <main>
        {isMobile && (
          <MobileMenuIcon
            slideMenu={slideMenu}
            activeCategories={activeCategories}
            all={all}
          />
        )}
        <Filter
          activeL1={activeCategories.L1}
          activeL2={activeCategories.L2}
          activeL3={activeCategories.L3}
          categoryList={categoryList}
          isMobile={isMobile}
          handleFilterChange={handleFilterChange}
          handleSearchValue={handleSearchValue}
        />

        {showModal && (
          <Modal
            host={host}
            // isMobile={isMobile}
            showModal={showModal}
            currentItem={currentItem}
            closeModal={closeModal}
            toNextItem={toNextItem}
            toPreviousItem={toPreviousItem}
          />
        )}
        {itemData && (
          <ItemList host={host} itemData={itemData} openModal={openModal} />
        )}
        <div ref={loader} className='loaderDiv'>
          <p className='no-result-message'>Loading...</p>
        </div>

        {!isPending && itemData.length === 0 && (
          <p className='no-result-message'>
            Sorry your search did not return any results...
          </p>
        )}
      </main>
    </>
  );
}
export default Home;
